import { render, staticRenderFns } from "./tipo-aplicacao.vue?vue&type=template&id=102f6dc4&"
import script from "./tipo-aplicacao.vue?vue&type=script&lang=js&"
export * from "./tipo-aplicacao.vue?vue&type=script&lang=js&"
import style0 from "./tipo-aplicacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports